import React from 'react'

export default () => (
  <div className='account-view'>
    <section className='bot-border-black section-heading'>
      Related resources
    </section>
    <div>
      <center>Coming soon</center>
    </div>
  </div>
)
